import { render, staticRenderFns } from "./SysAppUpgradeList.vue?vue&type=template&id=478f6f6f&scoped=true&"
import script from "./SysAppUpgradeList.vue?vue&type=script&lang=js&"
export * from "./SysAppUpgradeList.vue?vue&type=script&lang=js&"
import style0 from "./SysAppUpgradeList.vue?vue&type=style&index=0&id=478f6f6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478f6f6f",
  null
  
)

export default component.exports